import Vue from 'vue'

/**
 * @author Jose Luis Ruiz <jose.ruiz@jbge.com.mx>
 *
 * Send invoices to attach to Purchase Order
 * @param id Purcgase order id
 * @param PDF
 * @param XML
 * @return {Object}
 */

const transformInvoice = ({ PDF, XML }) => {
    const formData = new FormData()
    formData.append('PDF', PDF)
    formData.append('XML', XML)
    return formData
  }

export default ({id}, payload) =>
  Vue.$http.post(`purchase/order/${id}/oc/files/`, transformInvoice(payload))


// WEBPACK FOOTER //
// ./src/services/purchase/purchaseOrder/attachInvoiceToPurchaseOrder.js